module.exports = __webpack_public_path__ + "img/before3.a657ed7f.png";